export const CenteredTitle = ({props: {header}}:any) => {
    return (<div className="p-panel-header" data-pc-section="header"><span className="p-panel-title text-center w-full" data-pc-section="title">{header}</span></div>)
}